import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { h2, paragraph } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div ``;
const Inner = styled.div `
  @media ${from(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 32px;
  }
`;
const Filter = styled.div `
  position: relative;
  z-index: 2;
  border-bottom: 1px solid ${brand.white};
`;
const Main = styled.div `
  grid-column: 1 / span 12;
`;
const Message = styled.p `
  ${paragraph}
  margin-top: var(--sectionMargin);
`;
const Loading = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 100;
`;
const CtaWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 84px;
`;
const ListTitle = styled.h2 `
  ${h2};
  margin: 50px 0 30px;
`;
export default {
    Container,
    CtaWrapper,
    Inner,
    ListTitle,
    Loading,
    Main,
    Message,
    Filter,
};
